<template>
  <v-main>
    <v-container fluid>
      <!-- Back Button -->
      <v-btn
        fab
        x-small
        class="mx-1 mb-4"
        color="white"
        elevation="2"
        @click="$router.back()"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <!-- Profile Card -->
      <v-card elevation="10" class="mt-4 pa-4" rounded="xl">
        <!-- Profile Header -->
        <v-row class="ma-0" align="center">
          <v-col cols="12" sm="2" class="text-center text-sm-left">
            <v-list-item-avatar size="65">
              <img
                :src="
                  form.image_path
                    ? mediaUrl + form.image_path
                    : require('@/assets/voe_imgs/logo.jpeg')
                "
                alt="Profile"
              />
            </v-list-item-avatar>
          </v-col>
          <v-col cols="12" sm="10">
            <v-row class="ma-0">
              <v-col cols="12" class="blue--text text-h5 font-weight-bold pa-0">
                {{ user.full_name }}
              </v-col>
            </v-row>
            <v-row class="ma-0" v-if="user.roles[0].name === 'Employee'">
              <v-col cols="12" md="6" class="pa-0">
                {{ calculateAge(user.dob) }} yrs,
                {{ user.title === "Mr." ? "Male" : "Female" }}
                <v-col cols="12" md="6" class="pa-0 font-weight-bold">
                  {{ user.employee_id }}
                </v-col>
              </v-col>
              <!-- <v-row class="mt-6" v-if="user.roles[0].name === 'Employee'"> -->
              <v-col cols="12" md="6" class="pa-0">
                <v-btn
                  color="primary"
                  rounded
                  elevation="2"
                  class="mx-2 my-2 text-capitalize"
                  :to="`/leave-application-forms`"
                >
                  <!-- @click="viewLeaveRecords" -->
                  View Leave Records
                </v-btn>
              </v-col>
              <!-- </v-row> -->
            </v-row>
          </v-col>
        </v-row>

        <!-- Personal Details Section -->
        <v-row class="mt-4">
          <v-col cols="12">
            <h3 class="text-h5 font-weight-bold mb-4">Personal Details</h3>
          </v-col>
          <v-col cols="12" md="6">
            <!-- Email -->
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Email</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  v-model="form.email"
                  placeholder="Email"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Mobile Number -->
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Mobile Number</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  v-model="form.mobile"
                  placeholder="Mobile"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Aadhar -->
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Aadhar</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  v-model="form.aadhar_no"
                  placeholder="Aadhar"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Marital Status -->
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Marital Status</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  :v-model="
                    form.marital_status != null ? form.marital_status.code : ''
                  "
                  placeholder="Marital Status"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- </v-col> -->
            <!-- GST (Client Only) -->
            <v-row class="mx-2 my-2" v-if="user.roles[0].name === 'Client'">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">GST</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  v-model="user.sites[0].gst_no"
                  placeholder="GST"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Address (Client Only) -->
            <v-row class="mx-2 my-2" v-if="user.roles[0].name === 'Client'">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Address</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  v-model="user.sites[0].address"
                  placeholder="Address"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Address</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  placeholder="Address"
                  outlined
                ></v-text-field>
                <!-- v-model="form.joined_on" -->
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6" v-if="user.roles[0].name === 'Employee'">
            <!-- Father's Name -->
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Father's Name</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  v-model="form.father_name"
                  placeholder="Father's Name"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Date of Birth -->
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Date of Birth</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  v-model="form.dob"
                  placeholder="Date of Birth"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Pen Card -->
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Pen Card</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  v-model="form.pan_no"
                  placeholder="Pen Card"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Date on join -->
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Date of join</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  v-model="form.joined_on"
                  placeholder="Date of join"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Permanant address -->
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Permanant Address</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  placeholder="Permanant Address"
                  outlined
                ></v-text-field>
                <!-- v-model="form.joined_on" -->
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- Bank Details Section (Employee Only) -->
        <v-row class="mt-6" v-if="user.roles[0].name === 'Employee'">
          <v-col cols="12">
            <h3 class="text-h5 font-weight-bold mb-4">Bank Details</h3>
          </v-col>
          <v-col cols="12" md="6">
            <!-- Bank Name -->
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Bank Name</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  v-model="form.bank_name.name"
                  placeholder="Bank Name"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Account Number -->
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Account Number</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  v-model="form.bank_acc_no"
                  placeholder="Account Number"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6">
            <!-- IFSC Code -->
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">IFSC Code</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  v-model="form.bank_ifsc_code"
                  placeholder="IFSC Code"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Branch Name -->
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Branch Name</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  v-model="form.bank_branch"
                  placeholder="Branch Name"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- Previous Job Details Section (Employee Only) -->
        <v-row class="mt-6" v-if="user.roles[0].name === 'Employee'">
          <v-col cols="12">
            <h3 class="text-h5 font-weight-bold mb-4">Previous Job Details</h3>
          </v-col>
          <v-col cols="12" md="6">
            <!-- Previous Employer -->
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Previous Employer</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  placeholder="Previous Employer"
                  outlined
                ></v-text-field>
                <!-- v-model="form.previous_jobs[0].employer" -->
              </v-col>
            </v-row>
            <!-- Job Title -->
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Job Title</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  placeholder="Job Title"
                  outlined
                ></v-text-field>
                <!-- v-model="form.previous_jobs[0].job_title" -->
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6">
            <!-- Start Date -->
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Start Date</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  placeholder="Start Date"
                  outlined
                ></v-text-field>
                <!-- v-model="form.previous_jobs[0].start_date" -->
              </v-col>
            </v-row>
            <!-- End Date -->
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">End Date</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  placeholder="End Date"
                  outlined
                ></v-text-field>
                <!-- v-model="form.previous_jobs[0].end_date" -->
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- Education Details Section (Employee Only) -->
        <v-row class="mt-6" v-if="user.roles[0].name === 'Employee'">
          <v-col cols="12">
            <h3 class="text-h5 font-weight-bold mb-4">Education Details</h3>
          </v-col>
          <v-col cols="12" md="6">
            <!-- Degree -->
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Degree</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  placeholder="Degree"
                  outlined
                ></v-text-field>
                <!-- v-model="form.user_educations[0].qualification[0].code" -->
              </v-col>
            </v-row>
            <!-- Institution -->
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Institution</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  placeholder="Institution"
                  outlined
                ></v-text-field>
                <!-- v-model="form.user_educations[0].institute" -->
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6">
            <!-- Year of Completion -->
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Year of Completion</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  placeholder="Year of Completion"
                  outlined
                ></v-text-field>
                <!-- v-model="form.user_educations[0].to" -->
              </v-col>
            </v-row>
            <!-- Grade/Percentage -->
            <v-row class="mx-2 my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Grade/Percentage</h5>
                <v-text-field
                  hide-details
                  solo
                  dense
                  readonly
                  rounded
                  placeholder="Grade/Percentage"
                  outlined
                ></v-text-field>
              </v-col>
              <!-- v-model="form.user_educations[0].grade" -->
            </v-row>
          </v-col>
        </v-row>
      </v-card>

      <!-- Footer -->
      <v-container class="footer-text mt-6">
        <v-row justify="center">
          <v-col align="center">
            <h3 class="white--text">We Alliance Sparkle</h3>
            <h4 class="white--text">v 1.0.0</h4>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      form: {
        blood_group_code: "",
      },
      designation: "",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let form = await axios.get(`/users/${this.user.id}`);
      this.form = form.data.data;
      this.form.blood_group_code =
        this.form.blood_group != null ? this.form.blood_group.code : "";

      const findDesignation = this.form.user_categories.find(
        (item) => item.category.category_name == "DESIGNATION"
      );

      this.designation = findDesignation
        ? findDesignation.category_list.name
        : "";
      this.isLoading = false;
    },
    calculateAge(birthdate) {
      const now = moment();
      const birthdateMoment = moment(birthdate);
      const years = now.diff(birthdateMoment, "years");
      return years;
    },
  },
};
</script>
